"use client";

import { getCustomDomainComponents } from "@thenounproject/lingo-core";
import Script from "next/script";
import React from "react";
import { settings } from "shared";

const Scripts: React.FC = () => {
  // Don't render scripts for the fort
  const { subdomain } = getCustomDomainComponents();
  if (subdomain?.match(/^fort(\.|$)/)) {
    return null;
  }

  return (
    <>
      {GoogleTagManager()}
      {Apollo()}
      {LinkedIn()}
      {Intercom()}
      {Hubspot()}
      {Clarity()}
    </>
  );
};

export default Scripts;

// MARK : The scripts
// -------------------------------------------------------------------------------

function GoogleTagManager() {
  if (!settings.googleTagManagerUrl) return null;

  return (
    <Script
      id="google-tag-manager"
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `(function(w,d,s,l){w[l]=w[l]||[];w[l].push({"gtm.start":Date.now(),event:"gtm.js"});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=1;j.src="${settings.googleTagManagerUrl}";f.parentNode.insertBefore(j,f)})(window,document,"script","dataLayer");function gtag(){window.dataLayer&&window.dataLayer.push(arguments);}`,
      }}
    />
  );
}

function Apollo() {
  if (!settings.apolloAppId) return null;

  return (
    <Script
      id="apollo-tracker"
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `function initApollo(){var n=Math.random().toString(36).substring(7),o=document.createElement("script"); o.src="https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache="+n,o.async=!0,o.defer=!0, o.onload=function(){window.trackingFunctions.onLoad({appId:"${settings.apolloAppId}"})}, document.head.appendChild(o)}initApollo();`,
      }}
    />
  );
}

function LinkedIn() {
  if (!settings.linkedInPartnerId) return null;
  return (
    <>
      <Script
        id="linkedin-partner"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
          _linkedin_partner_id = "${settings.linkedInPartnerId}";
          window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
          window._linkedin_data_partner_ids.push(_linkedin_partner_id);
          (function(l) {
            if (!l) {
              window.lintrk = function(a, b) {
                window.lintrk.q.push([a, b]);
              };
              window.lintrk.q = [];
            }
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript";
            b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            s.parentNode.insertBefore(b, s);
          })(window.lintrk);
          `,
        }}
      />
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=${settings.linkedInPartnerId}&fmt=gif" />`,
        }}
      />
    </>
  );
}

export function Intercom() {
  if (!settings.intercomAppId) return null;

  return (
    <>
      {/* Initialize Intercom settings */}
      <Script
        id="intercom-settings"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.intercomSettings = { app_id: "${settings.intercomAppId}" };
            window.Intercom = window.Intercom || function() {
              (window.Intercom.q = window.Intercom.q || []).push(arguments);
            };
          `,
        }}
      />

      {/* Load Intercom widget script */}
      <Script
        id="intercom-widget"
        src={`https://widget.intercom.io/widget/${settings.intercomAppId}`}
        strategy="lazyOnload"
        onLoad={() => {
          // Reattach if Intercom was already loaded
          if (typeof window.Intercom === "function") {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            window.Intercom("reattach_activator");
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            window.Intercom("update", window.intercomSettings);
          }
        }}
      />
    </>
  );
}

const Hubspot = () => {
  if (!settings.hubspotId) return null;

  return (
    <Script
      strategy="lazyOnload"
      type="text/javascript"
      id="hubspot"
      async
      defer
      src={`//js-na2.hs-scripts.com/${settings.hubspotId}.js`}
    />
  );
};

function Clarity() {
  if (!settings.clarityId) return null;

  return (
    <Script
      id="microsoft-clarity"
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y)})(window,document,"clarity","script","${settings.clarityId}");`,
      }}
    />
  );
}
